import { ResourceGroupBase } from '../../resource_group_base'

/**
 * Enums.
 *
 * @class
 */
export class Enums extends ResourceGroupBase {
  // TODO: add jsdoc
  getMakers () {
    return this._makeCallBuilder()
      .appendUrlSegment('makers')
      .get()
  }

  getCountries () {
    return this._makeCallBuilder()
      .appendUrlSegment('countries')
      .get()
  }

  getFuels () {
    return this._makeCallBuilder()
      .appendUrlSegment('fuels')
      .get()
  }

  getTransmissions () {
    return this._makeCallBuilder()
      .appendUrlSegment('transmissions')
      .get()
  }

  getWheels () {
    return this._makeCallBuilder()
      .appendUrlSegment('wheels')
      .get()
  }

  _makeCallBuilder () {
    return this._server._makeCallBuilder().appendUrlSegment('enums')
  }
}
